export const buttonGroup = {
  textAlign: 'right',
}

export const segment = {
  padding: 30,
}
